<script setup lang="ts">
import { DISCORD_INVITE_URL } from '../../lib/constants'
</script>

<template>
  <footer class="bg-surface-400 border-t border-surface-100 py-8">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-gray-400 text-sm">
          &copy; {{ new Date().getFullYear() }} Integr8Games. All rights reserved.
        </div>
        <div class="flex items-center gap-6">
          <a 
            :href="DISCORD_INVITE_URL" 
            target="_blank" 
            class="text-gray-400 hover:text-[#5865F2] transition-colors flex items-center gap-2"
          >
            <font-awesome-icon :icon="['fab', 'discord']" class="text-lg" />
            Discord
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
